import React from 'react'
import PropTypes from 'prop-types'
import CaseStudiesListItem from '../item/caseStudiesListItem'
import './caseStudiesListBlock.css'

const CaseStudiesListBlock = ({ data }) => {
  return (
    <section className="caseStudiesListBlock">
      <div className="inner">
        {data.items &&
          data.items.map((item, index) => (
            <CaseStudiesListItem
              data={{
                content: item.caseStudy,
                index: index,
              }}
              key={`item-${index}`}
            ></CaseStudiesListItem>
          ))}
      </div>
    </section>
  )
}

CaseStudiesListBlock.propTypes = {
  data: PropTypes.object,
}

CaseStudiesListBlock.defaultProps = {
  data: {
    content: {
      title: 'Featured work',
      leader: 'Active Matter is an experience design & innovation agency',
    },
    items: [],
  },
}

export default CaseStudiesListBlock
